import * as React from "react"
import PropTypes from "prop-types"
import { AccordionContext } from "components/Accordion"
import cx from "classnames"

export const AccordionContent = ({ children }) => {
  const { expanded, accordionSummaryId, accordionContentId } =
    React.useContext(AccordionContext)

  return (
    <div
      id={accordionContentId}
      aria-labelledby={accordionSummaryId}
      role="region"
      className={cx({ "mt-5": expanded })}
    >
      {children(expanded)}
    </div>
  )
}

AccordionContent.propTypes = {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
}
